import { useState } from "react";
import usePageState from "../../../hooks/usePageState";
import { FilterRequest } from "../../../../applications/constants/AppTypes";
import { AdminUserModel } from "../../../../infrastructure/model/AppUserModel";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import ActionHeader from "../../../components/ActionHeader";
import ReloadOutlined from "@ant-design/icons/lib/icons/ReloadOutlined";
import BaseTable from "../../../components/BaseTable";
import PlusCircleOutlined from "@ant-design/icons/lib/icons/PlusCircleOutlined";
import useModal from "../../../hooks/useModal";
import CreateUserDialog from "./CreateUserDialog";
import { findUserByPageUseCase } from "../../../../applications/useCase/ApiUseCase/UserApiUseCase";

function ListUser() {
  const [listUsers, setListUsers] = useState<AdminUserModel[]>([]);
  const [filter, setFilter] = useState<FilterRequest & { user_name: string }>({
    limit: 30,
    page: 1,
    user_name: "",
  });
  const [total, setTotal] = useState<number>(0);
  const [createModal, openCreateModal] = useModal();

  const { showError, setLoading, isLoading } = usePageState();

  async function getUserPage() {
    const res = await findUserByPageUseCase({
      page: filter.page,
      limit: filter.limit,
      userName: filter.user_name,
      showError,
      setLoading,
    });
    if (res) {
      setListUsers(res.data);
      setTotal(res.total);
    }
  }

  async function handleOpenCreateDialog() {
    const result = await openCreateModal((close) => {
      return <CreateUserDialog onClose={close} />;
    });
    if (result) {
      await getUserPage();
    }
  }

  useAsyncEffect(async () => {
    await getUserPage();
  }, [filter.page]);

  return (
    <div className="h-100 flex flex-column">
      <ActionHeader
        actions={[
          {
            icon: <ReloadOutlined />,
            isNormal: true,
            userClick: getUserPage,
            type: "primary",
          },
          {
            icon: <PlusCircleOutlined />,
            isNormal: true,
            userClick: handleOpenCreateDialog,
            type: "primary",
          },
        ]}
      />
      <div className="flex-1">
        <BaseTable
          dataSource={listUsers}
          loading={isLoading}
          columns={[
            {
              title: "ID",
              dataIndex: "id",
              key: "id",
              width: 50,
            },
            {
              title: "Tên người dùng",
              dataIndex: "full_name",
              key: "full_name",
              width: 250,
            },
            {
              title: "Số điện thoại",
              dataIndex: "phone_number",
              key: "phone_number",
              width: 100,
            },
            {
              title: "Số đơn hàng đã mua",
              dataIndex: "total_orders",
              key: "total_orders",
              width: 100,
            },
            {
              title: "Số tiền đã chi tiêu",
              dataIndex: "total_spent",
              key: "total_spent",
              width: 200,
              render: (value : number) => {
                return (value?.toLocaleString() ?? 0) + " VNĐ";
              }
            },
            {
              title: "Hạng thành viên",
              dataIndex: "member_level",
              key: "member_level",
              width: 100,
            },
          ]}
          rowKey={"id"}
          pagination={{
            pageSize: 30,
            total: total,
            onChange(page, pageSize) {
              setFilter({
                ...filter,
                page: page,
              });
            },
          }}
        />
      </div>
      {createModal}
    </div>
  );
}

export default ListUser;
